import { TabManager } from './TabManager';

export * from './TabManager';
export * from './TabManager.interface';
// For backward compatibility
export default TabManager;
